module.exports = __webpack_public_path__ + "37a02bd5f0240bf8b587ce919761a1d0.MP3";